import { InfoCardDefault } from "@omni/components/components/General/InfoCard/infoCard.default";
import { useProductPageContext } from "@omni/components/components/ProductPage/context/productPage.context";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { DamImage } from "@omni/components/utils/dam.utils";
import { cn } from "@omni/utils/styles";

type Props = {
    className?: string;
};

export const InfoCardsComponent = ({ className }: Props) => {
    const { t } = useGranite();

    const {
        infoCards,
        isEcochequesAccepted,
        isClickAndCollectAvailable,
        isExclusivelyOnline,
        isWebOnly
    } = useProductPageContext();

    return (
        <div className={cn("tw:flex tw:flex-col tw:gap-2", className)}>
            {isEcochequesAccepted && (
                <InfoCardDefault
                    description={t("infoCard.ecoCheques.description")}
                    title={t("infoCard.ecoCheques.title")}
                    icon={DamImage.icon.label.ecoCheques()}
                    iconAltText={t("infoCard.ecoCheques.iconAltText")}
                    link={infoCards.ecoChequeLink}
                    linkLabel={t("infoCard.ecoCheques.linkLabel")}
                />
            )}
            {isClickAndCollectAvailable && (
                <InfoCardDefault
                    description={t("infoCard.transport.description")}
                    title={t("infoCard.transport.title")}
                    icon={DamImage.icon.label.transport()}
                    iconAltText={t("infoCard.transport.iconAltText")}
                    link={infoCards.transportLink}
                    linkLabel={t("infoCard.transport.linkLabel")}
                />
            )}
            {isExclusivelyOnline && (
                <InfoCardDefault
                    description={t("infoCard.exclusivelyOnline.description")}
                    title={t("infoCard.exclusivelyOnline.title")}
                    icon={DamImage.icon.label.homeDelivery()}
                    iconAltText={t("infoCard.exclusivelyOnline.iconAltText")}
                    link={infoCards.homeDeliveryLink}
                    linkLabel={t("infoCard.exclusivelyOnline.linkLabel")}
                />
            )}
            {isWebOnly && (
                <InfoCardDefault
                    description={t("infoCard.webOnly.description")}
                    title={t("infoCard.webOnly.title")}
                    icon={DamImage.icon.label.webOnly()}
                    iconAltText={t("infoCard.webOnly.iconAltText")}
                    link={infoCards.webOnlyLink}
                    linkLabel={t("infoCard.webOnly.linkLabel")}
                />
            )}
        </div>
    );
};
